import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';

import { useSiteConfig } from '@bingads-webui-campaign-react/smart-page-context';

import { SmartProfessionalServiceView } from './smart-professional-service-view';
import { proxyReadProfessionalServicesComponentConfig } from './component-config-reader';

export const SmartProfessionalServiceConnector = ({ id }) => {
  const { siteConfig } = useSiteConfig();

  const services = proxyReadProfessionalServicesComponentConfig(siteConfig);

  return (
    !isEmpty(services)
      ? <SmartProfessionalServiceView
        id={id}
        services={services}
      />
      : null
  );
};

SmartProfessionalServiceConnector.propTypes = {
  id: PropTypes.string.isRequired,
};
